<template>
<v-form @submit.prevent="onSubmit($event)">
<v-card class="elevation-12">
    <v-toolbar flat tabs color="grey lighten-3">
        <v-toolbar-side-icon @click="exit">
            <v-icon color="primary">close</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title v-if="type">Editar Categoria</v-toolbar-title>
        <v-toolbar-title v-else>Nova Categoria</v-toolbar-title>
        <v-spacer></v-spacer>
        <div>
            <v-switch
            v-if="type && type.highlight"
            v-model="typeForm.carousel"
            label="Mostrar Carrossel"
            color="primary"
            hide-details
            >
            </v-switch>
            <v-switch
            v-else
            v-model="typeForm.enabled"
            label="Ativo"
            color="primary"
            hide-details
            >
                <template v-slot:append>
                    <sp-tooltip tip="Marque para ocultar na lista de categorias.">
                    </sp-tooltip>
                </template>
            </v-switch>
        </div>
    </v-toolbar>
    <v-card-text class="pt-0" id="typeForm">
        <v-container grid-list-md pa-0 fluid>
            <v-layout row wrap>
                <v-flex xs12 sm8>
                    <v-layout row wrap justify-center>
                        <v-flex xs12>
                            <v-text-field  
                            label="Nome" type="text" outline
                            v-model="typeForm.name" required
                            clearable id="name" v-validate="'required'"
                            data-vv-name="name"
                            :error-messages="errors.collect('name')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea 
                            label="Descrição" type="text" outline
                            v-model="typeForm.description" required
                            rows="2" clearable
                            ></v-textarea>
                        </v-flex>
                        <v-flex xs12>
                            <v-autocomplete
                            v-model="typeForm.categoria_id"
                            :items="categories"
                            outline
                            chips
                            label="Tipo de categoria"
                            item-text="categoria"
                            item-value="_id"
                            :filter="filter"
                            clearable
                            id="categoria_id" v-validate="'required'"
                            data-vv-name="categoria_id"
                            :error-messages="errors.collect('categoria_id')"
                            >
                            <template v-slot:selection="data">
                                <v-avatar size="32">
                                    <img :src="uri+data.item.photo">
                                </v-avatar>
                                {{ data.item.categoria }}
                            </template>
                            <template v-slot:append-outer>
                                <sp-tooltip tip="O Tipo de categoria define a foto padrão</br>dos produtos cadastrados sem foto">
                                </sp-tooltip>
                            </template>
                            <template v-slot:item="data">
                                <v-list-tile-avatar>
                                    <img :src="uri+data.item.photo">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.categoria"></v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 v-if="!type">
                            <v-combobox
                                v-model="typeForm.subtypes"
                                :search-input.sync="search"
                                :hide-no-data="!search"
                                hide-selected
                                label="Subcategorias"
                                multiple
                                outline
                                chips
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                    :key="JSON.stringify(data.item)"
                                    :selected="data.selected"
                                    :disabled="data.disabled"
                                    class="v-chip--select-multi"
                                    @click.stop="data.parent.selectedIndex = data.index"
                                    @input="data.parent.selectItem(data.item)"
                                    >
                                    {{ data.item }}
                                    <v-icon small @click.stop="data.parent.selectItem(data.item)">close</v-icon>
                                    </v-chip>
                                </template>
                                <template v-slot:append-outer>
                                    <sp-tooltip tip="Crie ou Escolha uma subcategoria para</br>facilitar na busca do produto.</br>(Ex: Bebidas - Alcoólicas, Refrigerantes, Sucos...)">
                                    </sp-tooltip>
                                </template>
                                <template v-slot:no-data>
                                <v-list-tile>
                                    <v-list-tile-content>
                                    <v-list-tile-title>
                                        Pressione <kbd>enter</kbd> para criar uma nova
                                    </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                </template>
                            </v-combobox>
                        </v-flex>
                        <template v-else>
                            <v-flex xs12>
                                <v-divider></v-divider>
                                <v-subheader>Subcategorias</v-subheader>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="subtype.name"
                                    :label="(subtype._id)?'Editar subcategoria':'Nova subcategoria'"
                                    outline
                                    append-outer-icon="add"
                                    @click:append-outer="newSubtype"
                                    :autofocus="editSt"
                                    @keydown.enter.prevent="newSubtype"
                                    :error-messages="stError"
                                    :success-messages="stSuccess"
                                    :loading="stLoading"
                                    ref="subtypes"
                                    :append-icon="(subtype._id)?'close':null"
                                    @click:append="subtype={name:''};getSubtypes()"
                                    :hint="stHint"
                                    @blur="stHint = (subtypes.length>0)?'Clique em uma subcategoria para editá-la':null"
                                    @focus="stHint='Pressione <kbd>enter</kbd> para salvar'"
                                    persistent-hint
                                >
                                </v-text-field>
                                <div class="text-xs-center">
                                    <v-chip outline
                                        v-for="st in subtypes" 
                                        :key="st.name"
                                        @click="editSubtype(st)"
                                        :color="(st == subtype)?'success':'accent'"
                                        disabled
                                    >
                                        {{st.name}}
                                        <v-icon small @click.stop="delData = {func:removeSubtype,id:st};deleteDialog = true">
                                            close
                                        </v-icon>
                                    </v-chip>
                                </div>
                            </v-flex>
                        </template>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-layout row justify-center pl-2 pt-2 fill-height>
                        <v-flex xs7 sm12 v-if="typeForm.image">
                            <v-img :src="((typeForm.image.startsWith('data'))?'':uri)+typeForm.image" 
                                width="100%" class="grey lighten-2" aspect-ratio="1" contain
                                >
                                <v-container fill-height fluid pa-0>
                                    <v-layout row wrap justify-center align-center>
                                        <v-btn class="sp-transparent-red" dark @click="typeForm.image = ''">
                                            Remover
                                        </v-btn>
                                    </v-layout>
                                </v-container>
                            </v-img>
                            <span class="body-1 grey--text lighten-1">Imagem quadrada. Formato JPEG ou JPG. Máx: 500KB</span>
                        </v-flex>
                        <v-flex xs12 v-else>
                            <image-selector
                                hide-preview 
                                hide-after-crop
                                v-model="typeForm.image"
                                @start="cropping=true"
                                @end="cropping=false"
                                v-if="typeDialog"
                            >
                                <template #cropperActions="{handles}">
                                    <v-layout justify-center>
                                        <v-btn icon flat @click="handles.handleCropButtonClick"
                                            color="success" large ref="cropImage"
                                        >
                                            <v-icon>check</v-icon>
                                        </v-btn>
                                        <v-btn icon flat @click="handles.handleResetButtonClick"
                                            color="warning" large
                                        >
                                            <v-icon>undo</v-icon>
                                        </v-btn>
                                        <v-btn icon flat @click="handles.handleCancelButtonClick"
                                            color="error" large
                                        >
                                            <v-icon>block</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </template>
                                <template #uploaderActions="{handles}">
                                    <v-img width="100%" class="grey lighten-2" aspect-ratio="1" contain>
                                        <v-container fill-height fluid pa-0>
                                            <v-layout row wrap justify-center align-center>
                                                <v-flex xs12 class="subheading text-xs-center">
                                                    <span>Cole a sua imagem</span>
                                                </v-flex>
                                                <v-btn @click="handles.handleSelecionarButtonClick"
                                                >
                                                    anexar
                                                    <v-icon right>attach_file</v-icon>    
                                                </v-btn>
                                            </v-layout>
                                        </v-container>
                                    </v-img>
                                </template>
                            </image-selector>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
        <span id="errorType" class="error--text">{{error}}</span>
    </v-card-text>
    <v-card-actions class="row layout justify-center">
        <v-btn color="success" large type="submit" class="mb-3" :loading="loading" :disabled="loading">
            Salvar Categoria
        </v-btn>
    </v-card-actions>
    <v-dialog v-model="deleteDialog" lazy max-width="250px">
        <v-card>
            <v-card-text class="headline text-xs-center">
                Tem certeza que deseja excluir?
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
            <v-btn
                color="black"
                flat
                @click="deleteDialog = false"
                :disabled="loading"
            >
                Não
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="red"
                flat
                @click="delData.func(delData.id)"
                :loading="loading"
                :disabled="loading"
            >
                Sim
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-card>
</v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import ImageSelector from "@/components/cropper/ImageSelector";
export default {
    $_veeValidate: {
        validator: 'new'
    },
    components:{
        ImageSelector
    },
    data(){
        return {
            error:'',
            typeForm:{
                name:'',
                categoria_id:'',
                image: '',
                subtypes:[],
                description: '',
                enabled:true,
                carousel:false,
            },
            subtypes:[],
            mode:false,
            loading:false,
            categories:[],
            uri:'https://api.socialplace.com.br',
            search:"",
            delData:{func:null,id:""},
            stLoading:false,
            stSuccess:[],
            deleteDialog:false,
            subtype:{name:""},
            editSt:false,
            stError:[],
            stHint:null,
            cropping:false
        }
    },
    computed:{
        ...mapGetters([
            'util',
            'restaurant',
            'menu',
            'type',
            'typeDialog',
            'typeSelected'
        ])
    },
    watch:{
        typeDialog(v){
            if(v){
                this.setForm()
            }
        },
        subtype(){
            this.editSt = true
        },
        error(v){
            if(v){
                this.$vuetify.goTo('#errorType','#typeForm')
            }
        }
    },
    methods:{
        filter(item, queryText, itemText){
            return this.replaceSpecialChars(itemText.toLocaleLowerCase())
            .indexOf(this.replaceSpecialChars(queryText.toLocaleLowerCase())) > -1 ||
            this.replaceSpecialChars(item.tags.toLocaleLowerCase())
            .indexOf(this.replaceSpecialChars(queryText.toLocaleLowerCase())) > -1
        },
        filterSubtype(item, queryText, itemText){
            return this.replaceSpecialChars(itemText.toLocaleLowerCase())
            .indexOf(this.replaceSpecialChars(queryText.toLocaleLowerCase())) > -1
        },
        replaceSpecialChars(str){
            str = str.replace(/[ÀÁÂÃ]/,"A");
            str = str.replace(/[àáâã]/,"a");
            str = str.replace(/[ÈÉÊẼ]/,"E");
            str = str.replace(/[èéêẽ]/,"e");
            str = str.replace(/[ÌÍÎĨ]/,"I");
            str = str.replace(/[ìíîĩ]/,"i");
            str = str.replace(/[ÒÓÔÕ]/,"O");
            str = str.replace(/[òóôõ]/,"o");
            str = str.replace(/[ÙÚÛŨ]/,"U");
            str = str.replace(/[ùúûũ]/,"u");
            str = str.replace(/[Ç]/,"C");
            str = str.replace(/[ç]/,"c");

            return str.replace(/[^a-z0-9]/gi,''); 
        },
        async setForm(){
            
            const res = await this.$store.dispatch('getCategories')
            this.categories = res.data.data.categorias_produtos
            if(this.restaurant.clinicEnabled){
                this.categories = this.categories.filter(category => category.clinic_category === true)
            }else if(this.restaurant.restaurantEnabled){            
                this.categories = this.categories.filter(category => category.restaurant_category === true)
            }else{
                this.categories = res.data.data.categorias_produtos
            }                  
            if(this.type){
                this.typeForm = Object.assign(this.typeForm,this.type)
                this.getSubtypes()
            }
        },
        exit(){
            this.typeForm = {
                name:'',
                categoria_id:'',
                subtypes:[],
                image: '',
                enabled: true,
                carousel:false,
                description: '',
            }
            this.error = ''
            this.$validator.reset()
            setTimeout(() => {
                this.$emit('close')
            }, 200);
        },
        async onSubmit(event){
            if(this.cropping){
                this.error = "Confirme a imagem para continuar"
                return
            }else{
                this.error = ''
            }
            let valid = await this.$validator.validateAll()
            if(valid){
                this.loading = true
                const data = Object.assign({},this.typeForm)
                if((!data.image || !data.image.startsWith("data:image")) && !data.image.startsWith("/"))
                    data.image = ""
                this.$store.dispatch('createType',data).then(res=>{
                    if(!res.ok){
                        console.log(res.error);
                        this.error = res.error
                    }else{
                        this.$store.commit('FETCH_TYPE',null)
                        this.exit()
                    }
                    this.loading = false
                }).catch(err=>{
                    console.log(err);
                    this.error = "Ocorreu um erro inesperado."
                    this.loading = false
                })
            }
        },
        async getSubtypes(){
            this.stLoading = true    
            const res = await this.$store.dispatch('getSubtypes',this.type._id)
            if(res.data.ok){
                if(this.typeSelected && this.type._id == this.typeSelected._id)
                    this.$store.commit('SET_SUBTYPES',res.data.data)
                this.subtypes = res.data.data
                if(this.subtypes.length>0)
                    this.stHint = "Clique em uma subcategoria para editá-la"
                else
                    this.stHint = null
            }
            this.stLoading = false
        },
        newSubtype(){
            if(!this.subtype.name || this.subtype.name.trim() == ''){
                this.stError = 'Nome não pode ser vazio'
                return
            }
            this.stLoading = true
            const data = {
                name:this.subtype.name.trim(),
                type_id:this.type._id
            }
            if(this.subtype._id){
                data.subtype_id = this.subtype._id
            }
            this.$store.dispatch('createSubtype',data).then(res=>{
                if(!res.data.ok){
                    console.log(res.data.error);
                    this.stError = res.data.error
                }else{
                    this.stSuccess = (this.subtype._id)?
                    "Subcategoria editada com sucesso":
                    "Subcategoria criada com sucesso."
                    setTimeout(() => {
                        this.stSuccess = []
                    }, 3000);
                    this.stError = ""
                    this.subtype = {name:""}
                    this.getSubtypes()
                }
                this.stLoading = false
            }).catch(err=>{
                console.log(err);
                this.stError = "Ocorreu um erro inesperado."
                this.stLoading = false
            })
        },
        removeSubtype(subtype){
            this.stLoading = true
            const data = {
                subtype_id:subtype._id
            }
            this.$store.dispatch('removeSubtype',data).then(res=>{
                if(!res.data.ok){
                    console.log(res.data.error);
                    this.error = res.data.error
                }else{
                    this.error = ""
                    this.subtype = {name:""}
                    this.getSubtypes()
                }
                this.stLoading = false
            }).catch(err=>{
                console.log(err);
                this.error = "Ocorreu um erro inesperado."
                this.stLoading = false
            })
            this.deleteDialog = false
        },
        editSubtype(v){
            this.subtype = v
            this.$refs.subtypes.focus()
        }
    }
}
</script>

<style>

</style>
